export default __webpack_public_path__ + "static/media/diamond-color-1@3x.7dcdc026.png";